import { render } from "./DashboardItem.vue?vue&type=template&id=49f375f3&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"

import "./DashboardItem.vue?vue&type=style&index=0&id=49f375f3&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f375f3"]])

export default __exports__